import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  PopulateTeamMetadataMutation,
  PopulateTeamMetadataMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const populateTeamMetadataDocument = graphql(`
  mutation populateTeamMetadata {
    populateTeamMetadata {
      success
    }
  }
`);

export function usePopulateTeamMetadata(
  options?: UseMutationOptions<
    PopulateTeamMetadataMutation,
    unknown,
    PopulateTeamMetadataMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(populateTeamMetadataDocument, options);
}
